import { render, staticRenderFns } from "./d-activity-book.vue?vue&type=template&id=222b6818&scoped=true&"
import script from "./d-activity-book.vue?vue&type=script&lang=js&"
export * from "./d-activity-book.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-book.vue?vue&type=style&index=0&id=222b6818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b6818",
  null
  
)

export default component.exports